module.exports = __webpack_public_path__ + "img/iconWoDeYunXingRiZhi.7d2bf61b.svg";